module.exports = __webpack_public_path__ + "static/media/athena_space.4dd30ebf.png";